import { c as _c } from "react/compiler-runtime";
import s from "./stylesSK.module.scss";
import hs from "@/app/HomePage/HomePage.module.scss";
export default function HomeSK() {
  const $ = _c(8);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <nav className={s.navContainer} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className={s.hprojectsContainer}><div className={s.htitle} /><p className={s.htext} /><div className={s.element} /></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className={s.titleh3} />;
    t3 = <div className={s.text} />;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className={s.hppWrapper}>{t2}{t3}<div className={s.hprojectsWrapper}><div className={s.ppFlip} /><div className={s.ppFlip} /><div className={s.ppFlip} /></div></div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className={s.titleh3} />;
    t6 = <div className={s.text} />;
    $[5] = t5;
    $[6] = t6;
  } else {
    t5 = $[5];
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className={hs.homeContainer}>{t0}{t1}{t4}<div className={s.hppWrapper}>{t5}{t6}<div className={s.hprojectsWrapper}><div className={s.ppInfo} /><div className={s.ppInfo} /></div></div><div className={s.subtit} /><div className={s.social} /><div className={s.social} /><footer className={s.footer} /></div>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  return t7;
}